"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = /** @class */ (function () {
    function Constants() {
    }
    // Constants for IC3 Headers
    Constants.NewMessageEvent = "NewMessage";
    Constants.MessageUpdateEvent = "MessageUpdate";
    Constants.ThreadUpdateEvent = "ThreadUpdate";
    Constants.ConversationUpdateEvent = "ConversationUpdate";
    Constants.HttpLongPoll = "HttpLongPoll";
    Constants.ContentTypeJson = "application/json";
    Constants.ContentTypeTextPlain = "text/plain;charset=UTF-8";
    Constants.ContentTypeForm = "application/x-www-form-urlencoded";
    Constants.RedirectAs404 = "redirectAs404";
    Constants.NoCache = "no-cache";
    Constants.User = "user";
    Constants.Web = "web";
    Constants.ClientInfoValue = "os=Windows; osVer=10; proc=Win32; lcid=en-us; deviceType=1; country=IN; clientName=swc; clientVer=912/0.106.0.34//swc";
    Constants.TextPlainMimeType = "text/plain";
    Constants.SwcName = "SWC";
    Constants.Image = "image";
    Constants.ClientVersion = "937/0.123.0.9";
    Constants.DelayForAms = 50;
    Constants.Reset_Flag = "reset_ic3_needed";
    // AMS File Status Constants
    Constants.Malware = "malware";
    Constants.Ready = "ready";
    Constants.InProgress = "in progress";
    Constants.Failed = "failed";
    Constants.Expired = "expired";
    // AMS URL Constants - used to generate AMS URL's
    Constants.ImageView = "imgpsh_fullsize_anim";
    Constants.FileView = "original";
    Constants.DocumentTypeImage = "pish/image";
    Constants.DocumentTypeFile = "sharing/file";
    Constants.ImageContent = "imgpsh";
    Constants.FileContent = "original";
    // AMS Headers Constants
    Constants.AMSAcceptHeaderValue = "image/webp,image/ *,*/*;q=0.8";
    Constants.AMSAcceptEncodingHeaderValue = "gzip, deflate, sdch, br";
    Constants.AMSAuthorizationSkypeTokenValue = "skype_token ";
    // Constants to stabilize new poll creation
    Constants.stabilizePollMaxRetryCount = 50;
    Constants.timeBetweenStabilizingPoll = 1000; // time in milliseconds (1 sec)
    // Constants for operation retries
    Constants.retryCount = 2; // retry the same request within HttpClient
    Constants.retry404Count = 3;
    Constants.retryOtherCount = 3;
    Constants.liveStateRetryCount = 3;
    Constants.timeBetweenOperationRetry = 1000; // time in milliseconds (1 sec)
    Constants.heartBeatDuration = 30000; // time in milliseconds (30 sec)
    // Log constants
    Constants.endpointRequestLog = "Endpoint request";
    Constants.subscriptionRequestLog = "Subscription request";
    Constants.setPropertiesRequestLog = "Set message properties request";
    Constants.unsubscribeRequestLog = "Unsubscribe from endpoint request";
    Constants.pollRequestLog = "Polling";
    Constants.oldInitializer = "Old initializer";
    Constants.newInitializer = "New Initializer";
    // Constants for AMS URL to set the cookie
    Constants.skypeTokenAuthURL = "/v1/skypetokenauth";
    Constants.skypeTokenConstantForData = "skypetoken=";
    return Constants;
}());
exports.default = Constants;
//# sourceMappingURL=Constants.js.map